export const NewProjectModalTranslations = {
  en: {
    newProjectModal: {
      standard: "Standard",
      custom: "Custom",
    },
  },
  es: {
    newProjectModal: {
      standard: "Estándar",
      custom: "Personalizado",
    },
  },
};
